import React from 'react';
import { BUSINESS } from '../config/business';

function CTAButton({ children, size = 'md', className = '', ...props }) {
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-6 py-3.5 sm:px-8 sm:py-4 text-base sm:text-lg'
  };

  const baseClasses = `
    inline-flex items-center justify-center font-semibold rounded-lg 
    bg-blue-600 text-white hover:bg-blue-700 
    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 
    transition-all duration-200 shadow-sm hover:shadow-md 
    active:scale-[0.98]
    ${sizeClasses[size]}
    ${className}
  `;

  return (
    <a
      href={BUSINESS.ctaLink}
      target="_blank"
      rel="noopener noreferrer"
      className={baseClasses}
      {...props}
    >
      {children}
    </a>
  );
}

export default CTAButton;